import {Subscription} from "rxjs";

import {BaseStoreInterface} from "./base-store-interface";
import {EventAnalysisStoreService} from "../event-analysis-store.service";
import {EventEmitter} from "@angular/core";
import {ErrorCodes} from "../../../common/enums/states/error-codes";

export class BaseStore implements BaseStoreInterface {
  subscription: Subscription = new Subscription();
  isRegistered: boolean = false;
  updateNotifier: EventEmitter<any> = new EventEmitter<any>()
  errorCode: ErrorCodes | undefined = ErrorCodes.loading

  constructor(
    public eventAnalysisStoreService: EventAnalysisStoreService
  ) {
    this.register();
  }

  update() {
  }

  initialize() {
  }


  register(): void {
    if (this.isRegistered)
      return
    this.isRegistered = true
    this.subscription.add(this.eventAnalysisStoreService.initializedNotifier.subscribe(() => {
        this.initialize()
      }
    ))

    this.subscription.add(this.eventAnalysisStoreService.updateNotifier.subscribe(() => {
        this.update()
      }
    ))

    this.subscription.add(this.eventAnalysisStoreService.errorNotifier.subscribe((errorCode) => {
        this.errorCode = errorCode
      }
    ))
  }
}
